import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const PUBLIC_API = `${BACKEND_URL.replace(/\/+$/, "")}/api/membership`;

const http = axios.create({ baseURL: PUBLIC_API, timeout: 15000 });

// Phase 30A — when a Phase 23 member-auth session token is available,
// forward it as a Bearer header so the backend can resolve the caller's real
// persisted tier (Enterprise / Executive / Professional / Free) instead of
// defaulting to anonymous. Token is read from the same storage keys used by
// AuthContext to avoid coupling either side directly.
const AUTH_TOKEN_KEYS = [
  "carelogix_member_token",  // primary — set by /app/frontend/src/api/authClient.js
  "carelogix.auth.token",
  "oracle.auth.token",
  "oracle.session_token",
  "oracle.access_token",
];

function readAuthToken() {
  try {
    if (typeof window === "undefined") return null;
    for (const k of AUTH_TOKEN_KEYS) {
      const v = window.localStorage.getItem(k);
      if (v) return v;
    }
  } catch { /* ignore */ }
  return null;
}

http.interceptors.request.use((cfg) => {
  const t = readAuthToken();
  if (t && cfg && cfg.headers) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const membershipApi = {
  tiers:          () => http.get("/tiers"),
  featureMatrix:  () => http.get("/feature-matrix"),
  me:             (tier) => http.get("/me", { params: tier ? { tier } : undefined }),
};
